import React, { useEffect, useState, Dispatch } from 'react'
import { Button, Table, Spin } from 'antd'
import type { ColumnsType } from 'antd/lib/table';
import { ProgressBar, Status } from './InvetoryTableUtils';
import { LoadingOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { getBPTable } from "../../api/BPTable/BPTableMethods"
import { IBox } from "../interface/interface"
import SelectOLPN from "./../home/SelectOLPN"
import { useUserContext } from "../../userContext"
import "./inventory.css"

interface DataType {
  sku: string;
  key: string;
  bpNumber: number;
  progression: number[];
  status: string;
  id: string;
}

const InventoryTable = (props: {
  checkedBox: IBox, slider: [number, number], dateRange: { start: Date | undefined, end: Date | undefined },
  data: any, setData: Dispatch<any>
}) => {
  const { checkedBox, slider, dateRange, data, setData } = props
  let navigate = useNavigate()
  const { user } = useUserContext()
  const [loading, setLoading] = useState<boolean>(false)
  const [selectedBp, setSelectedBp] = useState<any | undefined>(undefined)
  const [isOpen, setOpen] = useState<boolean>(false)


  useEffect(() => {
    getData()
  }, [])

  useEffect(() => {
    getData()
  }, [checkedBox, slider, dateRange])

  const getData = async () => {
    setLoading(true)
    const res = await getBPTable(checkedBox, slider, dateRange.start, dateRange.end)
    if (res === 'ERR_NETWORK')
      setData([])
    else
      setData(res)
    setLoading(false)
  }

  const handleButton = (record: DataType) => {
    if (user?.group === "admin") {
      navigate('/edit/' + record.bpNumber + "/" + record.sku, { state: record })
    } else {
      // navigate("/scanning/" + record.bpNumber + "/" + record.sku, { state: record })
      setOpen(true);
      setSelectedBp(record)
    }
  }

  const handleEdit = (record: DataType) => {
    navigate('/edit/' + record.bpNumber + "/" + record.sku, { state: record })
  }

  const columns: ColumnsType<DataType> = [
    {
      title: 'N° BP',
      dataIndex: 'bpNumber',
      key: 'BP',
      render: text => <span className='bold-text'>{text}</span>,
      width: 100
    },
    {
      title: "SKU",
      dataIndex: 'sku',
      key: "SKU",
      render: text => <span className='bold-text'>{text}</span>,
      width: 100
    },
    {
      title: "Progression",
      dataIndex: 'progression',
      key: 'progression',
      render: (elem, record) => <ProgressBar percentage={Math.floor(elem[0] / elem[1] * 100)} progress={elem[0]} max={elem[1]} status={record.status} />,
      width: 65
    },
    {
      title: "Statut",
      dataIndex: 'status',
      key: 'statut',
      render: (status) => <Status status={status} />,
      width: 100
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      render: (_text, record, _index) => (
        <>
          <Button
            disabled={user?.group !== "admin" && record.status === "COMPLETE" ? true : false}
            id={"edit-button-" + record.bpNumber} className='action-button' onClick={() => { handleButton(record) }}>{user?.group === 'admin' ? "Editer" : "Lancer le controle"}</Button>
          {user?.group === "user" && <Button onClick={() => { handleEdit(record) }}>Voir</Button>}
        </>
      ),
      width: 200
    }
  ];

  return (
    <div>
      <SelectOLPN bp={selectedBp} setOpen={setOpen} isOpen={isOpen} />
      <Spin spinning={loading} indicator={<LoadingOutlined className='loading-icon' />} tip="Chargement des données, veuillez patienter">
        <Table className='card-table'
          rowKey={(record) => record.bpNumber}
          pagination={{
            total: data?.length,
            pageSize: 10,
            itemRender(page, type, element) {
              if (type === 'prev') return <Button className='rounded-button'>Précédent</Button>
              if (type === 'next') return <Button className='rounded-button'>Suivant</Button>
              return element
            },
          }} columns={columns} dataSource={data} />
      </Spin>
    </div>
  )
}

export default InventoryTable